import React from 'react';
import { connect } from 'react-redux';
import { Row, Col, BackTop, Button, Breadcrumb } from 'antd';
import { DoubleRightOutlined, PlusOutlined } from '@ant-design/icons';
import { TableList } from 'components/list';
import ModalForm from '../modal/Form';
import ModalDelete from '../modal/Delete';
import SearchTable from 'components/search-table/SearchTable';
import { HeaderPenghargaanSiswa, PageHeader } from 'components/header';
import columns from './Columns';
import useList from '../hooks/useList';
import { isAuth } from 'lib/Helper';
import AuthRedirect from 'components/AuthRedirect';
import { Link } from 'react-router-dom/cjs/react-router-dom';
import { SortingTableOnly } from 'components/sorting-table';

const sortFields = [{
  value: "id",
  label: "Tanggal Pembuatan",
}];

const PenghargaanSiswaDetail = ({ privilege }) => {
  const {
    action,
    table,
    formState,
    deleteState,
    fetchTable,
    fetchData,
    modalForm,
    modalDelete,
  } = useList(privilege);

  if (!isAuth(privilege) || (action === undefined)) {
    return <AuthRedirect />
  }

  return (
    <>
      <PageHeader
        style={{
          padding: 0
        }}
        onBack={() => window.history.back()}
        title={<Breadcrumb style={{ margin: '16px 0' }} separator={<DoubleRightOutlined />}>
          <Breadcrumb.Item>Kesiswaan</Breadcrumb.Item>
          <Breadcrumb.Item><Link to="/kesiswaan/penghargaan-siswa">Penghargaan Siswa </Link></Breadcrumb.Item>
          <Breadcrumb.Item>Detail </Breadcrumb.Item>
        </Breadcrumb>}
      />

      <HeaderPenghargaanSiswa />

      <div className="site-layout-background" style={{ padding: 24, minHeight: 360 }}>
        <PageHeader
          className="site-page-header"
          title="Detail Penghargaan Siswa"
          subTitle="Data detail penghargaan siswa"
          extra={[
            action.create && (
              <Button
                type='primary'
                onClick={() => modalForm(true)}
                icon={<PlusOutlined />}>
                Tambah
              </Button>
            ),
          ]} />

        <Row gutter={[16, 16]}>
          <Col xs={24} sm={18} md={19}>
            <SearchTable table={table} fetch={fetchData} />
          </Col>
          <Col xs={24} sm={6} md={5}>
            <SortingTableOnly
              table={table}
              fetch={fetchData}
              sortFields={sortFields}
            />
          </Col>
          <Col xs={24}>
            <TableList
              state={{ table }}
              fetch={fetchData}
              fetchTable={fetchTable}
              columns={columns(action, modalForm, modalDelete)}
            />
          </Col>
        </Row>
      </div>
      {formState.visible && (
        <ModalForm
          data={formState.data}
          visible={formState.visible}
          hideModal={() => modalForm(false)}
          fetchTable={fetchTable}
        />
      )}
      {deleteState.visible && (
        <ModalDelete
          data={deleteState.data}
          visible={deleteState.visible}
          hideModal={() => modalDelete(false)}
          fetchTable={fetchTable}
        />
      )}
      <BackTop />
    </>
  );
};

const mapStateToProps = (state) => ({
  privilege: state.privilege,
});

export default connect(mapStateToProps)(PenghargaanSiswaDetail);